import isIBAN from 'validator/lib/isIBAN'

import { Cache } from '~/services/cache/Cache.ts'

const cache = Cache.tags('validation')

interface ValidateEmailOptions {
  unique?: boolean
  blocked_domains?: boolean
}

export async function validateEmail(emails: string | string[], options: ValidateEmailOptions = {}) {
  if (!emails) {
    return false
  }

  if (!Array.isArray(emails)) {
    emails = [emails]
  }

  try {
    await api.post('validate-emails', { emails, ...options }, { key: null })

    return true
  } catch {
    return false
  }
}

interface ValidateTransactionIdentifierOptions {
  unique?: boolean
}

export async function validateTransactionIdentifier(transactionIdentifiers: string | string[], options: ValidateTransactionIdentifierOptions = {}) {
  if (!transactionIdentifiers) {
    return true
  }

  if (!Array.isArray(transactionIdentifiers)) {
    transactionIdentifiers = [transactionIdentifiers]
  }

  try {
    await api.post('validate-transaction-identifiers', { transactionIdentifiers, ...options }, { key: null })

    return true
  } catch {
    return false
  }
}

export async function validateTaxId(value: string) {
  if (!value) {
    return true
  }

  return await cache.remember(`tax-id:${value}`, dayjs().add(1, 'day'), async () => {
    try {
      await api.post('validate-tax-id', { tax_id: value }, { key: null })

      return true
    } catch {
      return false
    }
  })
}

export async function validatePhoneNumber(value: string) {
  try {
    await api.post('validate-phone-number', { phone_number: value }, { key: null })
  } catch {
    return false
  }

  return true
}

export async function validateURL(url: string | string[]) {
  try {
    await api.post('validate-urls', { urls: Array.isArray(url) ? url : [url] }, { key: null })
  } catch {
    return false
  }

  return true
}

export function validateIBAN(iban: null | string): boolean {
  if (!iban) {
    return false
  }

  return isIBAN(iban)
}

const hexCodeRegExp = /#[a-fA-F\d]*/
export function validateHexCode(hexCode: string) {
  return hexCodeRegExp.test(hexCode)
}
